import { useCallback, useEffect, useState } from 'react'
import { updateRelevantDataButtonStyles, updateSearchIconStyles } from '../utils/updateBazaarvoiceStyles'

// context: https://maxedadiy.atlassian.net/browse/SHOP-38864
// As it’s not possible no apply all the necessary brand styles via configuration in the in the BV dashboard
// we're updating them on particular elements when bazaarvoice fragment is loaded
export function useUpdateBazaarvoiceStyles() {
  const [bvReviewsShadowRoot, setBvReviewsShadowRoot] = useState(null)

  // 1. observing the appearance of the shadow DOM in the <div data-bv-show='reviews' ... />
  // => means that bazaarvoice reviews fragment is attached
  const observeBazarvoiceReviewsAppearance = useCallback(() => {
    const shadowRoot = document.querySelector('div[data-bv-show="reviews"]')?.shadowRoot
    if (!shadowRoot) return

    setBvReviewsShadowRoot(shadowRoot)
  }, [setBvReviewsShadowRoot])

  // 2. observing the appearance of specific HTML elements inside of the shadow DOM
  // and updating them when they appear
  const updateBazaarvoiceStyles = useCallback(() => {
    if (!bvReviewsShadowRoot) return

    updateRelevantDataButtonStyles(bvReviewsShadowRoot)
    updateSearchIconStyles(bvReviewsShadowRoot)
  }, [bvReviewsShadowRoot])

  useEffect(() => {
    const observer = new MutationObserver(
      bvReviewsShadowRoot ? updateBazaarvoiceStyles : observeBazarvoiceReviewsAppearance
    )
    const targetElement = bvReviewsShadowRoot ?? document.body
    observer.observe(targetElement, {
      childList: true,
      subtree: true
    })

    return () => {
      if (!observer) return
      observer.disconnect()
    }
  }, [bvReviewsShadowRoot, observeBazarvoiceReviewsAppearance, updateBazaarvoiceStyles])
}
